export default {
  CUSTOM: 'custom',
  GROUP: 'group',
  SURVEY: 'survey',
} as const;
